import React, { useState, useEffect } from "react";

import { Box, Card, Grid, FormLabel, Divider, RadioGroup, Autocomplete, FormControlLabel, Radio, Typography, Button, Tooltip, TableContainer, Modal, Table, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme } from "@mui/material";
import ReportsHeader from "../../../components/ReportHeader";
import dayjs from "dayjs";
import Searchicon from '@mui/icons-material/Search';
import jsPDF from 'jspdf';

import { useRef } from "react";

import CallAlertBar from "../../../Layout/Alertbar";
import 'dayjs/plugin/customParseFormat';
import * as XLSX from "xlsx";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import GlobalConfig from "../../../config/date/GlobalConfig";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

import PrintPreview from "../reports/PrintPreview";
import PrintPreviewReamBundleConvertionRpt from "../reports/PrintPreviewReamBundle";
const ReelPendingConversionReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [partyList, setPartyList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');

    // Fallback colors in case tokens are undefined
    const primaryColor = colors?.primary?.[500] || '#1976d2';  // Default blue if undefined
    const secondaryColor = colors?.secondary?.[500] || '#5293fa';  // Default red if undefined


    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [open, setOpen] = useState(false);
    const [indentNoList, setIndentNoList] = useState([]);

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
    };

    const [indentno, setIndentno] = useState('');
    const [batchno, setBatchno] = useState('');

    const [lineno, setlineno] = useState(0);
    const callbackPdf = () => {

        setViewReport(false);
    }



    const [filters, setFilters] = useState({
        pr_number: '',
        child_reel_number: '',
        no_of_cuts: '',
        reelsize: '',
        no_of_sheets: '',

    });
    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });






    //////////////////////////////////////////////////////////////////////////////////////////////
    const [selectedOption, setSelectedOption] = useState('order'); // Default to "Order"


    const [viewReport, setViewReport] = useState(false);
    const [parentRoll, setparentRoll] = useState([]);

    const reportRef = useRef();

    const generatePDF = () => {
        setViewReport(true);
        const doc = new jsPDF({
            format: 'a4',
            unit: 'pt'
        });

        doc.html(reportRef.current, {
            callback: function (doc) {
                doc.save('JumboQCTestCertificate.pdf');
            },
            x: 10,
            y: 10,
            width: 575, // A4 page width - margins
            windowWidth: 800, // The window width to use for rendering
        });
    };




    const getReportData = (indentno_value) => {

        let parameters = {
            p_indent_no: indentno_value.indent_no,
            p_line_no: lineno,
        };

        if (!indentno_value) {
            setPartyList([]);
            setViewReport(false);
        }
        else {
            callApi(API_ENDPOINTS.REPORT_GetProductionOrderWiseReelPendingConversionDet, 'POST', { 'Content-Type': 'application/json' }, parameters)
                .then(data => {
                    // Update state with fetched data
                    if (data.length > 0) {
                        setPartyList(data);
                        setViewReport(true);
                    }
                    else {
                        setPartyList([]);
                        setViewReport(false);
                        alert('No pending reel details found!')
                    }
                })
                .catch(error => {
                    alert(error);
                });
        }



    };

    const btnSearchOrderWisePendingReelDet = (indentno_value) => {

        if (indentno_value.indent_no === '') {

            alert('Please enter order details for search');
            return;
        }

        getReportData(indentno_value);

    }

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleIndentNoChange = (event, value) => {
        if (value !== undefined && value != null) {
            setIndentno(value);

            btnSearchOrderWisePendingReelDet(value);
        }
        else {
            setIndentno('');

            btnSearchOrderWisePendingReelDet('');
        }
    }

    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = now.getFullYear();
    const todayDate = `${day}-${month}-${year}`;


    // Define custom header rows with dynamic data
    const customHeader = [
        [
            `Date :-`, todayDate, "", `PLANING NO :-${partyList[0]?.planning_no || "N/A"}`, "", `PO NO :- ${indentno}-${lineno},`,
            `QUALITY :- ${partyList[0]?.item_code || "N/A"},`, `GSM :- ${partyList[0]?.gsm || "N/A"}`, `No of Sheets :- ${partyList[0]?.no_of_sheets || "N/A"}`, "", "", "", "", `CUTTER REPORT`
        ],
        [
            "NO OF REEL", "ROLL NO", "REEL NO.", "REEL WT.", "REEL SIZE", "NO OF CUT",
            "REEL USED", "SIZE A", "SIZE B", "NO OF SHEETS", "WEIGHT KG",
            "SHEETER NO.", "SHIFT", "OPERATOR NAME", "REMARK"
        ]
    ];

    const handleExportToExcel = () => {
        // Get today's date in dd-mm-yyyy format
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = now.getFullYear();
        const todayDate = `${day}-${month}-${year}`;



        // Prepare the data with headers
        const formattedData = partyList.map(row => ([
            row.id,
            row.pr_number,
            row.child_reel_number,
            row.achieved_qty,
            row.reelsize,
            row.no_of_cuts,
            row.reelused,
            row.width,
            row.length,
           row.no_of_sheets, // NO OF SHEETS
            '', // WEIGHT KG
            '', // SHEETER NO.
            '', // SHIFT
            '', // OPERATOR NAME
            ''  // REMARKS
        ]));

        // Combine header and data
        const combinedData = [...customHeader, ...formattedData];

        // Create a new worksheet with the combined data
        const worksheet = XLSX.utils.aoa_to_sheet(combinedData);

        // Apply styles for the first row (header)
        const headerStyle = { font: { bold: true, sz: 16 }, alignment: { horizontal: "center" } };
        const subHeaderStyle = { font: { bold: true, sz: 12 }, alignment: { horizontal: "center" } };

        // Apply styles for the first header row
        for (let col = 0; col < customHeader[0].length; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: col }); // First row, columns
            if (worksheet[cellRef]) worksheet[cellRef].s = headerStyle;
        }

        // Apply styles for the second header row
        for (let col = 0; col < customHeader[1].length; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: 1, c: col }); // Second row, columns
            if (worksheet[cellRef]) worksheet[cellRef].s = subHeaderStyle;
        }

        // Set column widths
        worksheet['!cols'] = [
            { wch: 15 }, // NO OF REEL
            { wch: 15 }, // ROLL NO
            { wch: 20 }, // REEL NO.
            { wch: 15 }, // REEL WT.
            { wch: 15 }, // REEL SIZE
            { wch: 15 }, // NO OF CUT
            { wch: 15 }, // Reel Used
            { wch: 15 }, // SIZE A
            { wch: 15 }, // SIZE B
            { wch: 15 }, // NO OF SHEETS
            { wch: 15 }, // WEIGHT KG
            { wch: 15 }, // SHEETER NO.
            { wch: 15 }, // SHIFT
            { wch: 20 }, // OPERATOR NAME
            { wch: 25 }  // REMARK
        ];

        // Create a workbook and append the styled worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Reel Pending Conversion");

        // Format filename as ddmmyyyy_HHMM
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const dateTime = `${day}${month}${year}_${hours}${minutes}`;
        const fileName = `Order Wise Reel Pending Conversion Report_${dateTime}.xlsx`;

        // Export the file
        XLSX.writeFile(workbook, fileName);
    };


    const fetchIndentNo = async () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 0,
        }

        try {
            const data = await callApi(API_ENDPOINTS.REPORT_GetProductionDistinctOrderNoForConversionReport, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data?.length > 0) {
                setIndentNoList(data);
            }
        }
        catch (error) {
            alert(error);
        }
    }


    useEffect(() => {
        fetchIndentNo();
    }, [])



    return (

        <Box style={{ backgroundColor: "transparent", height: '620px' }}>
            <Box style={{ backgroundColor: "#0277bd" }} flexDirection={'row'} p={'5px'}>
                <ReportsHeader title={'Order Wise Reel and Ream/Bundle Pending Conversion Reports'} subtitle="" callback={handleBackWinderMachineEntry} />
            </Box>

            <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


            <CardContent sx={{ border: "1px solid #3d3d3d" }}>
                <Box display="flex" flexDirection={'column'}>
                    <Box mb='5px' display="flex" justifyContent={'space-between'}>
                        <Grid container spacing={1} justifyContent="space-between" style={{ marginTop: '0px' }}>
                            <Box m='0px' display="flex" justifyContent={'start'}>
                                <Typography variant="h6" style={{ marginTop: '7px', width: '150px', fontSize: '14px' }}> Filter Input : </Typography>


                                {/* <TextField
                                            label="CO No."
                                            value={indentno}
                                            variant="outlined"
                                            onChange={(e) => setIndentno(e.target.value)} // Handle input changes
                                            size="small"
                                            sx={{ marginRight: 0.5 }} // Add some margin to the right for spacing
                                        /> */}


                                <Autocomplete
                                    fullWidth
                                    value={indentno}
                                    onChange={handleIndentNoChange}
                                    size="small"
                                    style={{ fontSize: '12px' }}
                                    options={indentNoList}
                                    getOptionLabel={(option) => (option?.indent_no ? `${option.indent_no}` : '')} // Safely handle undefined
                                    renderInput={(params) =>
                                        <TextField required

                                            {...params} variant="outlined" />}
                                />

                                {/* <IconButton  >
                                    <SearchIcon onClick={btnSearchOrderWisePendingReelDet} />
                                </IconButton> */}
                            </Box>




                            {viewReport && (
                                <Tooltip title="Download Report" >
                                    <IconButton onClick={handleExportToExcel}>
                                        <FileDownloadIcon style={{ color: "#1de9b6" }} />
                                    </IconButton>
                                </Tooltip>)}
                        </Grid>
                    </Box>



                </Box>

                {viewReport && (
                    <Box
                        // gridColumn="span 9"
                        gridRow={"span 2"}
                        alignItems="center"
                        justifyContent="center"
                        // padding={1}
                        sx={{
                            "& .MuiTable-root": {
                                border: "none",
                                size: "small",
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "none",
                                // fontWeight: "bold",
                                border: "1px solid ",
                                borderColor: `${colors.primary[400]} !important`,
                            },
                            "& .name-column--cell": {
                                color: colors.greenAccent[300],
                            },
                            "& .MuiTableHead-root": {
                                // backgroundColor: colors.blueAccent[700],
                                borderBottom: "none",

                            },
                            "& .MuiTableBody-root": {
                                overflowY: "auto",
                            },
                            "& .MuiCheckbox-root": {
                                color: `${colors.blueAccent[200]} !important`,
                                size: "small",
                            },
                            "& .MuiTableFooter-root": {
                                borderTop: "none",
                                backgroundColor: colors.blueAccent[700],
                                height: "10px",
                            },
                            "& .MuiButton-text": {
                                color: `${colors.grey[100]} !important`,
                            },
                            // backgroundColor: colors.primary[700],
                            // padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '65vh', // Large devices (desktops)
                                xl: '86vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling

                            // maxWidth: {
                            //     xs: '110vh', // Extra small devices (phones)
                            //     sm: '120vh', // Small devices (tablets)
                            //     md: '130vh', // Medium devices (small laptops)
                            //     lg: '145vh', // Large devices (desktops)
                            //     xl: '145vh', // Extra large devices (large desktops)
                            // },
                            // overflowX: 'auto',

                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }

                        }}>


                        <TableContainer >
                            <Table stickyHeader sx={{ tableLayout: 'fixed' }} size="small" >
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>

                                        <TableCell></TableCell>
                                        <TableCell sx={{ width: '100px' }}>ROLL NO</TableCell>
                                        <TableCell sx={{ width: '100px' }}>REEL NO</TableCell>
                                        <TableCell sx={{ width: '100px' }}>REEL WT </TableCell>
                                        <TableCell sx={{ width: '100px' }}>REEL SIZE </TableCell>
                                        <TableCell sx={{ width: '100px' }}>NO OF CUT </TableCell>
                                        <TableCell sx={{ width: '100px' }}>CLAC. SHEET </TableCell>
                                        <TableCell sx={{ width: '100px' }}> REWINDER REMARKS</TableCell>
                                        <TableCell sx={{ width: '100px' }}> ACTUAL SHEETS</TableCell>
                                        <TableCell sx={{ width: '120px' }}> NO OF PALLET</TableCell>
                                        <TableCell sx={{ width: '100px' }}> MACHINE NO</TableCell>
                                        <TableCell sx={{ width: '100px' }}> SHIFT</TableCell>
                                        <TableCell sx={{ width: '140px' }}> OPERATOR NAME</TableCell>
                                        <TableCell sx={{ width: '100px' }}> REMARKS</TableCell>

                                        <TableCell>
                                            <IconButton onClick={handleOpen}>
                                                <Searchicon style={{ fontSize: "16px" }} />
                                            </IconButton>
                                            <Modal
                                                open={open}
                                                onClose={handleClose}
                                                aria-labelledby="modal-modal-title"
                                                aria-describedby="modal-modal-description"
                                            >
                                                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                    <TextField
                                                        label="Parent Roll Number"
                                                        name="pr_number"
                                                        value={filters.pr_number}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        size="small"
                                                    />
                                                    <TextField
                                                        label="Child Reel Number"
                                                        name="child_reel_number"
                                                        value={filters.child_reel_number}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        size="small"
                                                    />

                                                    <TextField
                                                        label="Reel Size"
                                                        name="reelsize"
                                                        value={filters.reelsize}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        size="small"
                                                    />







                                                    <Button variant="contained" style={{ marginTop: 10 }}>
                                                        {/* onClick={handleClose} */}
                                                        Apply Filter
                                                    </Button>
                                                </Box>
                                            </Modal>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredData.map((row) => (
                                        <TableRow key={row.id}>

                                            <TableCell >{row.id}</TableCell>
                                            <TableCell>{row.pr_number}</TableCell>
                                            <TableCell>{row.child_reel_number}</TableCell>
                                            <TableCell>{row.achieved_qty}</TableCell>
                                            <TableCell>{row.reelsize}</TableCell>
                                            <TableCell>{row.no_of_cuts}</TableCell>
                                            <TableCell>{row.no_of_sheets}</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <PrintPreview parentRollDetails={partyList} cono={indentno.indent_no} quality={partyList[0]?.item_code} gsm={partyList[0]?.gsm} no_of_sheets={partyList[0]?.no_of_sheets}  />
                        <Divider />
                        <PrintPreviewReamBundleConvertionRpt parentRollDetails={partyList} cono={indentno.indent_no} />

                    </Box>
                )}

                {/* {viewReport && (
                    <PrintPreview parentRollDetails={partyList} cono={indentno} quality={partyList[0]?.item_code} gsm={partyList[0]?.gsm} />
                )} */}


                {/* 
            {viewReport && (

                <PrintPreviewReamBundleConvertionRpt parentRollDetails={partyList} cono={indentno} />
         
            )} */}
            </CardContent>
        </Box>

    )
};
export default ReelPendingConversionReport;